module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-Regular-f728eedd529b1b3ed5d44ac64bd2c8ae.eot";